import React from "react";
import {
  TableRow,
  TableCell,
  Stack,
  Link,
  Typography,
} from "@mui/material";
import MapIcon from "@mui/icons-material/Map";
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";

interface VehicleRowProps {
  item: any;
  tableBodyCellStyle: any;
  onEditVehicleNumber: (vehicleId: number, vehicleNo: string) => void;
  onDownloadRC: (item: any) => void;
  onDownloadInsurance: (item: any) => void;
  onTrackVehicle: (item: any) => void;
  onEditIoT: (item: any) => void;
}

const VehicleRow: React.FC<VehicleRowProps> = ({
  item,
  tableBodyCellStyle,
  onEditVehicleNumber,
  onDownloadRC,
  onDownloadInsurance,
  onTrackVehicle,
  onEditIoT,
}) => {
  const allottedStatusText =
    { "0": "Not Allotted", "1": "Allotted" }[String(item.allottedStatus)] ??
    "-";

  return (
    <TableRow>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
          <span>{item.vehicleNo}</span>
          <Tooltip title="Edit vehicle number">
            <EditIcon
              sx={{ color: "#00CD5B", cursor: "pointer", fontSize: "18px" }}
              onClick={() => onEditVehicleNumber(item.vehicleId, item.vehicleNo)}
            />
          </Tooltip>
        </div>
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        {item.allottedDate}
      </TableCell>
      <TableCell
        style={{
          ...tableBodyCellStyle,
          textAlign: "center",
          backgroundColor:
            item.allottedStatus === 1 ? "#E8F5E9" : "#FFEBEE",
          fontWeight: 500,
        }}
      >
        {allottedStatusText}
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        {item.fleetName}
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        {item.averageSpeed}
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        {item.totalDistanceTravelled}
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        {item.totalCarbonSaved}
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <span>{item.imei}</span>
          <Tooltip title="Edit IoT details">
            <EditIcon
              sx={{ color: "#00CD5B", cursor: "pointer", fontSize: "18px" }}
              onClick={() => onEditIoT(item)}
            />
          </Tooltip>
        </div>
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        <img
          src={"/assets/document.svg"}
          alt="document"
          onClick={() => onDownloadRC(item)}
          style={{
            cursor: "pointer",
            display: "block",
            margin: "auto",
            width: "24px",
            height: "24px",
          }}
          title="Download RC document"
        />
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        <img
          src={"/assets/document.svg"}
          alt="document"
          onClick={() => onDownloadInsurance(item)}
          style={{
            cursor: "pointer",
            display: "block",
            margin: "auto",
            width: "24px",
            height: "24px",
          }}
          title="Download insurance document"
        />
      </TableCell>
      <TableCell style={{ ...tableBodyCellStyle, textAlign: "center" }}>
        <Stack direction="row" spacing={0} justifyContent="center">
          <Tooltip title="Track vehicle">
            <Link
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => onTrackVehicle(item)}
            >
              <Typography variant="subtitle1" sx={{ color: "#00CD5B" }}>
                <MapIcon />
              </Typography>
            </Link>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default VehicleRow;
